document.querySelectorAll('[data-newsletter-btn]').forEach(button => {
  // Find parent form
  const form = button.closest('form');
  if (!form) return;

  // Find all required checkboxes in the form
  const checkboxes = form.querySelectorAll('input[type="checkbox"]');

  // Function to check all checkboxes — use aria-disabled for accessibility, opacity via CSS
  const checkAllChecked = () => {
    const allChecked = Array.from(checkboxes).every(chk => chk.checked);
    button.setAttribute('aria-disabled', allChecked ? 'false' : 'true');
    button.style.opacity = allChecked ? '1' : '0.5';
  };

  // Listen for changes on each checkbox
  checkboxes.forEach(chk => {
    chk.addEventListener('change', checkAllChecked);
  });

  // Run on page load in case some checkboxes are pre-checked
  checkAllChecked();
}); 
 
 
 document.querySelectorAll('.grid_lnk').forEach(card => {
  const video = card.querySelector('.grid_video');
  if (!video) return;

  card.addEventListener('mouseenter', () => {
    video.play();
  });

  card.addEventListener('mouseleave', () => {
    video.pause();
    video.currentTime = 0;
  });
});

document.addEventListener("change", function (event) {
  const checkbox = event.target;

  if (!checkbox || ( checkbox.id !== "termsCheck" && checkbox.id !== "cartPage_term")) return;

  const cartDrawer = checkbox.closest('#CartDrawer, cart-drawer, .cart-drawer, body');
  const checkoutBtn = cartDrawer.querySelector("#CartDrawer-Checkout,#cartCheckout");

  if (!checkoutBtn ) return;

  checkoutBtn.style.opacity = checkbox.checked ? "1" : "0.5";
});

